// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__qe-BQ","title":"Images90_title__2Mdvj","images":"Images90_images__2lJd1"};